import { render, staticRenderFns } from "./Pushtx.vue?vue&type=template&id=140f4e2e&scoped=true"
import script from "./Pushtx.vue?vue&type=script&lang=js"
export * from "./Pushtx.vue?vue&type=script&lang=js"
import style0 from "./Pushtx.vue?vue&type=style&index=0&id=140f4e2e&prod&lang=scss&scoped=true"
import style1 from "./Pushtx.vue?vue&type=style&index=1&id=140f4e2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140f4e2e",
  null
  
)

export default component.exports